module.exports = __webpack_public_path__ + "img/dbCorte.960e4a68.jpg";